"use strict";
class Kv {
    constructor() {
        this.sequenceIndex = 0;
        this.closeButton = document.querySelector("#mv-banner-close");
        this.banner = document.querySelector("#mv-banner");
        this.mvItems = document.querySelectorAll(".mvItem");
        this.mvList = document.querySelector("#mvList");
        this.mv = document.querySelector("#mv");
        if (this.closeButton != null) {
            // クリックイベントの設定
            this.closeButton.addEventListener("click", (e) => {
                console.log("close banner");
                e.preventDefault();
                this.closeBanner();
            });
        }
        //this.startAnimation();
        this.waitForImages();
    }
    waitForImages() {
        if (!this.mvList)
            return;
        // mvList内のすべての画像要素を取得
        const images = this.mvList.getElementsByTagName("img");
        const imagePromises = Array.from(images).map((img) => {
            return new Promise((resolve) => {
                if (img.complete) {
                    resolve();
                }
                else {
                    img.addEventListener("load", () => resolve());
                    img.addEventListener("error", () => resolve()); // エラー時も処理を継続
                }
            });
        });
        // すべての画像の読み込みを待つ
        Promise.all(imagePromises).then(() => {
            var _a;
            console.log("All images loaded");
            (_a = this.mv) === null || _a === void 0 ? void 0 : _a.classList.add("is-loaded");
            // 3秒後にアニメーションを開始
            setTimeout(() => {
                console.log("Starting animation after delay");
                this.startAnimation();
            }, 1000);
        });
    }
    closeBanner() {
        // バナーを非表示にする
        if (this.banner != null) {
            this.banner.remove();
        }
    }
    startAnimation() {
        setInterval(() => {
            // 指定された順序で要素を選択
            const currentItemIndex = Kv.ANIMATION_SEQUENCE[this.sequenceIndex];
            const currentItem = this.mvItems[currentItemIndex];
            if (!currentItem)
                return;
            // 現在のアニメーション状態を確認
            const hasOutClass = Kv.OUT_CLASSES.some((cls) => currentItem.classList.contains(cls));
            // すべてのクラスを削除
            [...Kv.OUT_CLASSES, ...Kv.IN_CLASSES].forEach((cls) => {
                currentItem.classList.remove(cls);
            });
            // 新しいクラスを追加
            if (hasOutClass) {
                const newInClass = Kv.IN_CLASSES[Math.floor(Math.random() * Kv.IN_CLASSES.length)];
                currentItem.classList.add(newInClass);
            }
            else {
                const newOutClass = Kv.OUT_CLASSES[Math.floor(Math.random() * Kv.OUT_CLASSES.length)];
                currentItem.classList.add(newOutClass);
            }
            // 次のインデックスに進む（シーケンスの最後まで来たら最初に戻る）
            this.sequenceIndex =
                (this.sequenceIndex + 1) % Kv.ANIMATION_SEQUENCE.length;
        }, 2000);
    }
}
Kv.OUT_CLASSES = [
    "fadeOut1",
    "fadeOut2",
    "fadeOut3",
    "fadeOut4",
];
Kv.IN_CLASSES = [
    "fadeIn1",
    "fadeIn2",
    "fadeIn3",
    "fadeIn4",
];
Kv.ANIMATION_SEQUENCE = [6, 4, 3, 5, 0, 7, 1, 8, 2];
if (document.querySelector("#mv")) {
    new Kv();
}
